import { render, staticRenderFns } from "./otocouform.vue?vue&type=template&id=5999466b&scoped=true&"
import script from "./otocouform.vue?vue&type=script&lang=js&"
export * from "./otocouform.vue?vue&type=script&lang=js&"
import style0 from "./otocouform.vue?vue&type=style&index=0&id=5999466b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5999466b",
  null
  
)

export default component.exports